export const getters = {
    getGrupoFinanceiro: state => state.grupoFinanceiro,
    getGruposFinanceiro: state => state.gruposFinanceiro,
    getModalCadastroGrupoFinanceiro: state => state.modalCadastroGrupoFinanceiro,
    getModalExcluirGrupoFinanceiro: state => state.modalExcluirGrupoFinanceiro,
}

export default {}